import React from 'react'
import PropTypes  from 'prop-types'
export default function Contactus(props) {
    return (
        <div className={` pdown container my-4 text-${props.mode==='light'?'black':'white'}`}>
            <h1 className='my-4 text-center'>Contact Us</h1>
            <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">Email address</label>
                <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com"/>
                </div>
                <div className="mb-3">
                <label htmlFor="exampleFormControlTextarea1" className="form-label">Your Query</label>
                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                <button type="button" className={`btn btn-${props.mode==='light'?'dark':'light'} col justify-content-center my-5`}>Submit</button>
            </div>
        </div>
    )
}
